import React, { useEffect, useState } from 'react';
import './Navigation.css';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, sectionClass) => {
    e.preventDefault();
    const section = document.querySelector(sectionClass);
    if (section) {
      const navbarHeight = 80; // высота navbar
      const elementPosition = section.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const openChatwoot = (e) => {
    e.preventDefault();
    if (window.$chatwoot) {
      window.$chatwoot.toggle('open');
    }
  };

  return (
    <nav id="navbar" className={scrolled ? 'scrolled' : ''}>
      <div className="nav-content">
        <div className="logo">
          <svg xmlns="http://www.w3.org/2000/svg" id="svg246769" viewBox="0 279 50 200" height="50px" width="50px" version="1.1">
            <defs id="defs246773"></defs>
            {/* Щит с глазом */}
            <g transform="translate(-26, 294) scale(0.89)">
              {/* Щит */}
              <path style={{fill: '#101726', stroke: '#cea726', strokeWidth: 8}} d="M35 44C35.0271 53.8141 37.1809 63.4671 39.3495 73C45.6655 100.763 57.6225 127.683 75.4491 150C82.8573 159.274 91.4729 166.839 100 175C110.142 167.94 118.529 158.619 126.193 149C148.585 120.896 164.447 82.1799 166 46C156.464 44.2033 147.124 42.6705 139 36.956C134.156 33.5486 129.867 25.1139 123.96 24.1481C113.521 22.4414 101.582 24 91 24C86.4634 24 80.3327 22.9482 76.0394 24.6034C71.3939 26.3943 68.1268 31.9328 64 34.7793C55.2967 40.7825 45.3931 43.1798 35 44z"/>
              {/* Eye Outline */}
              <path style={{fill: 'none', stroke: '#cea726', strokeWidth: 8}} d="M98 64.4784C88.3925 65.5546 80.2656 70.3045 73 76.439C70.6411 78.4307 66.2068 81.5249 66.2068 85C66.2068 88.4751 70.6411 91.5693 73 93.561C80.7574 100.111 91.3242 106.717 102 105.522C111.607 104.445 119.734 99.6955 127 93.561C129.359 91.5693 133.793 88.4751 133.793 85C133.793 81.5249 129.359 78.4307 127 76.439C119.243 69.8893 108.676 63.2826 98 64.4784z"/>
              {/* Pupil */}
              <circle cx="100" cy="85" r="12" style={{fill: 'none', stroke: '#cea726', strokeWidth: 8}}/>
            </g>
          </svg>
          <div className="logo-text">
            <span className="logo-title">SHADOW</span>
            <span className="logo-badge">PREMIUM</span>
          </div>
        </div>
        <div className="nav-links">
          <a href="#home" className="nav-link" onClick={(e) => scrollToSection(e, '.hero')}>Home</a>
          <a href="#how-it-works" className="nav-link" onClick={(e) => scrollToSection(e, '.how-it-works')}>How It Works</a>
          <a href="#modules" className="nav-link" onClick={(e) => scrollToSection(e, '.module-1-section')}>Modules</a>
          <a href="#contact" className="nav-link" onClick={(e) => {
            e.preventDefault();
            const s = document.querySelector('.cta-section');
            if (s) {
              const r = s.getBoundingClientRect();
              window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - (window.innerHeight - r.height) / 2), behavior: 'smooth' });
            }
          }}>Contact Us</a>
        </div>
        <button onClick={(e) => {
          e.preventDefault();
          const s = document.querySelector('.cta-section');
          if (s) {
            const r = s.getBoundingClientRect();
            window.scrollTo({ top: Math.max(0, r.top + window.pageYOffset - (window.innerHeight - r.height) / 2), behavior: 'smooth' });
          }
        }} className="cta-button">Get Free Consultation</button>
      </div>
    </nav>
  );
};

export default Navigation;
